document.addEventListener("DOMContentLoaded", function () {
  const containerGrid = document.querySelector(".products-main-grid");
  const productCards = document.querySelectorAll(".product-card-item");
  const trackingBgs = document.querySelectorAll(".tracking-bg-graphic");

  // --- CONTAINED BACKGROUND ALIGNMENT TRACKING WITH DIRECTIONAL OFFSETS ---
  productCards.forEach((card) => {
    card.addEventListener("mouseenter", function () {
      const index = parseInt(this.getAttribute("data-index"), 10);
      const targetBg = document.querySelector(`.tracking-bg-graphic[data-bg-index="${index}"]`);
      
      if (targetBg) {
        // Clear old active instances
        trackingBgs.forEach(bg => bg.classList.remove("active"));
        
        // Measure parent grid structure bounding dimensions
        const gridRect = containerGrid.getBoundingClientRect();
        const cardRect = this.getBoundingClientRect();
        
        // Calculate standard column center point alignment match coordinates
        let targetX = (cardRect.left - gridRect.left) + (cardRect.width / 2) - (targetBg.offsetWidth / 2);
        
        // --- CUSTOM DYNAMIC POSITION DIRECTIONAL OFFSETS ---
        // Increase this pixel number to push the left line more left and the right line more right
        const customOffsetValue = 0; 
        
        if (index === 1) {
          // Slide the first background image further left
          targetX = targetX - customOffsetValue;
        } else if (index === 3) {
          // Slide the third background image further right
          targetX = targetX + customOffsetValue;
        }
        // index 2 (middle) stays completely centered right under the column framework
        
        // Pass pixel value cleanly to the CSS translate property variable channel
        targetBg.style.setProperty("--track-x", `${targetX}px`);
        targetBg.classList.add("active");
      }
    });

    card.addEventListener("mouseleave", function () {
      trackingBgs.forEach(bg => bg.classList.remove("active"));
    });
  });

  // --- MODAL POPUP CONTROLLERS SYSTEM ---
  const openButtons = document.querySelectorAll(".trigger-open-ingredients");
  const closeButtons = document.querySelectorAll(".close-popup-btn");
  const overlays = document.querySelectorAll(".ingredient-popup-overlay");

  openButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const modalId = this.getAttribute("data-modal-id");
      const targetModal = document.getElementById(modalId);
      if (targetModal) {
        targetModal.classList.add("active-popup");
        document.body.style.overflow = "hidden";
      }
    });
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      this.closest(".ingredient-popup-overlay").classList.remove("active-popup");
      document.body.style.overflow = "";
    });
  });

  overlays.forEach((overlay) => {
    overlay.addEventListener("click", function (e) {
      if (e.target === this) {
        this.classList.remove("active-popup");
        document.body.style.overflow = "";
      }
    });
  });
});